exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checklist-item[data-v-780f8bf8]{width:48%;min-width:300px;margin-right:2%;margin-bottom:20px}@media (max-width:768px){.checklist-item[data-v-780f8bf8]{width:100%;margin-right:0}}", ""]);

// exports
